
String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
}


import React from "react";
import ReactDOM from "react-dom";
import { Suspense } from "react";
import MainLoader from "./components/UI/MainLoader";

import "./assets/css//bootstrap.min.css";

const App = React.lazy(() => import("./App"));

function Root() {

  return (
    <Suspense fallback={<MainLoader />}>
      <App />
    </Suspense>

  );
}

ReactDOM.render(<Root />, document.getElementById("root"));
